import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
    name: "unauthorized-view",
})
export default class UnauthorizedView extends Vue {}
